const FF_KEY = 'ff'

export function initFeatureFlags(): void {
  const params = new URLSearchParams(window.location.search)
  const value = params.get(FF_KEY)
  if (value !== null) {
    if (value === '') {
      localStorage.removeItem(FF_KEY)
    }
    else {
      localStorage.setItem(FF_KEY, value)
    }
  }
}

export function isFeatureEnabled(name: string): boolean {
  const raw = localStorage.getItem(FF_KEY) || ''
  return raw.split(',').some(f => f.trim() === name)
}
